<template>
  <div>
    <nav class="navbar navbar-expand navbar-dark bg-primary">
      <div class="container">
        <!--<a class="navbar-brand" href="#">AMPA Pablo Picasso - Admin</a>-->
        <ul class="navbar-nav mr-auto">
          <li class="active" id="nav-atras">
            <a class="nav-link" href="javascript:void(0);" @click="$router.go(-1)">◁</a>
          </li>
          <li class="nav-item" id="nav-mi-familia">
            <router-link to="/" class="nav-link">Personal</router-link>
          </li>
          <li class="nav-item" id="nav-familias">
            <router-link to="/admin/familias" class="nav-link">Familias</router-link>
          </li>
          <li class="nav-item" id="nav-actividades">
            <router-link to="/admin/actividades" class="nav-link">Actividades</router-link>
          </li>
          <li class="nav-item" id="nav-niveles">
            <router-link to="/admin/niveles" class="nav-link">Niveles</router-link>
          </li>
          <li class="nav-item" id="nav-tesoreria">
            <router-link to="/admin/tesoreria" class="nav-link">Tesorería</router-link>
          </li>
        </ul>
      </div>
    </nav>

    <div class="container py-3" id="contenido">
      <router-view/>
    </div>

  </div>
</template>

<script>

import { obtenerSesion } from '../api/api.js';

export default {
	name: 'AreaAdmin',
	data () {
		return {
			sesion: null,
		}
	},
	created () {
		this.sesion = obtenerSesion();
		if (! this.sesion || ! this.sesion.admin) {
			this.$router.push('/');
		}
	}
}
</script>
